export default {
  "typeHere" : "hier schreiben",
  "voice" : "Stimme"
}



// WEBPACK FOOTER //
// ./src/locales/de.js